import { Qualification } from "../types";

/**
 * Calculates the status of a qualification based on its expiry date.
 */
export const calculateQualificationStatus = (qualification: Qualification): "Active" | "Expiring Soon" | "Expired" => {
  if (!qualification.expiryDate) return "Active";

  const expiryDate = new Date(qualification.expiryDate);
  const now = new Date();
  
  // Set time to midnight for comparison
  now.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);

  if (expiryDate < now) {
    return "Expired";
  }

  // Define "Expiring Soon" as within 60 days
  const sixtyDaysFromNow = new Date();
  sixtyDaysFromNow.setDate(now.getDate() + 60);

  if (expiryDate <= sixtyDaysFromNow) {
    return "Expiring Soon";
  }

  return "Active";
};

/**
 * Gets the number of days until a date expires.
 */
export const getDaysUntilExpiry = (expiryDateString?: string): number | null => {
  if (!expiryDateString) return null;

  const expiryDate = new Date(expiryDateString);
  const now = new Date();
  
  now.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);

  const diffTime = expiryDate.getTime() - now.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

/**
 * Formats a date string into a localized format.
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};
